import styled from 'styled-components';
import { media } from '@minecraft.themes';

export const FormWrapper = styled.div`
  width: 100%;

  ${media.sm`
    width: 28rem;
  `};
`;

export const FieldStyles = styled.div`
  margin: 2rem 0;

  button {
    background-color: ${(props): string => props.theme.colors.primary.white};
    color: ${(props): string => props.theme.colors.primary.ltGrey1};
    border-left: none;
    font-weight: 500;
    border-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    outline: none;
    right: 1px;
  }
`;

export const StyledLoginPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  width: 100%;
  background-color: ${(props): string => props.theme.colors.accent.greyBlue4};
  min-height: 100vh;
`;

export const StyledPasswordRemark = styled.div`
  font-size: 0.74rem;
  line-height: 1;
  margin-top: 0.25rem;
`;

export const HelpTextEmphasized = styled.div`
  margin-top: 1rem;
  font-style: italic;
`;
